import FetchFactory from '../factory';

const CONTROLLER = '/api-electra/AfterSalesOffers';

class AfterSalesOffersModule extends FetchFactory<any> {
  async GetAfterSalesOffers(orderGuid: string) {
    const url = `${CONTROLLER}/GetAfterSalesOffers`;
    return await this.call('POST', url, {
      OrderGuid: orderGuid,
    });
  }
}

export default AfterSalesOffersModule;
